import { useTranslation } from "react-i18next";
import { countryOptions } from "@/constants/countries";

export default function CountryField({ visibleFields, value, onChange, showValidation }) {
  const { i18n } = useTranslation();
  const field = visibleFields.find((f) => f.id === "country");
  if (!field) return null;

  const isMandatory = field.mandatory === true;
  const isEmpty = !value || value.trim() === "";
  const showError = showValidation && isMandatory && isEmpty;
  const options = countryOptions(i18n.language);

  return (
    <div className="flex flex-col">
      <label htmlFor={field.id} className="input-label">
        {field.label} {isMandatory && "*"}
      </label>
      <select
        id={field.id}
        name={field.id}
        value={value || ""}
        onChange={onChange}
        className={`input ${showError ? "border-red-500" : ""}`}
      >
        <option value="">{field.label}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
}


